import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import InputField from "../../../../Components/Masters/InputField";
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import { validateNumber } from "../../../../utils/validateFields";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import { restructureData } from "../../../../utils/restructureData";
import DynamicStaticTable from "../../../../Components/Common/DynamicStaticTable";
import { validateLastRow } from "../../../../utils/validateTable";
import ReviewBox from "../../../../Components/Common/ReviewBox";

import { currentYear } from "../../../../utils/generateYearRanges";

const GRI305_7 = ({hide}) => {
    const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));
const inputData = [
    {
      fieldName: "airEmission",
      // title: "a. What are the significant air emissions from processes",
      type: "array",
      letter: "a.",
      fields: [
        {
          fieldName: "gasName",
          title: "Gas Name",
          type: "text",
          placeholder: "Enter Text",
          width: "44%",
        },
        // {
        //   fieldName: "unit",
        //   title: "Unit",
        //   type: "select",
        //   options: ["Tonns", "Liters", "M3", "Kg"],
        //   width: "30%",
        //   placeholder: "Select",
        // },
        {
          fieldName: "total",
          title: "Total Emission",
          type: "number",
          width: "44%",
          placeholder: "Enter Number",
        },
      ],
    },
  ];

  const defaultSegments = [
    "NOx",
    "SOx",
    "Persistent organic pollutants (POP)",
    "Volatile organic compounds (VOC)",
    "Hazardous air Pollutants (HAP)",
    "Particulate Matter (PM)",
  ];

  const questionData = [
    {
      fieldName: "emissionFactorCalculation",
      title: "Which emission factors were used for calculation?",
      type: "text",
      letter: "b.",
    },
    {
      fieldName: "calculationTools",
      title:
        "What standards, methodologies, assumptions, and/or calculation tools were used?",
      type: "text",
      letter: "c.",
    },
  ];

  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [tables, setTables] = useState([]);
  const [tabErrors, setTabErros] = useState({});
  const [data, setData] = useState({});
  const [formData, setFormData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GRI300`);
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
      const res1 = res?.data?.data?.GRI300?.airEmissionsNOxSOx;
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setFormData({
      emissionFactorCalculation: data?.emissionFactorCalculation || "",
      calculationTools: data?.calculationTools || "",
    });
  }, [data]);

  const handleChange = (fieldName, value, type, field) => {
    if (type === "number" && !validateNumber(value)) return;

    field
      ? setFormData((prev) => ({
          ...prev,
          [fieldName]: { ...prev?.[fieldName], [field]: value },
        }))
      : setFormData((prev) => ({
          ...prev,
          [fieldName]: value,
        }));
  };

  const handleSubmit = async () => {
    if (!disabled) {
      if (
        tables?.[0]?.rows?.length > defaultSegments?.length &&
        !validateLastRow(inputData, tables, setTabErros)
      )
        return;
      let transformedData2 = {
        airEmissionsNOxSOx: { ...restructureData(tables), ...formData },
        type: "GRI300",
        submitted305_7: true,
      };

      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/gri300/306-1/${id}`);
      } catch (error) {
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri300/306-1/${id}`);
    }
  };

  const renderContent = ({hide}) =>(
     <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      {!hide &&<p className={styles.section_heading}>305 : Emissions</p>}
      <p className={styles.main_heading} style={{ marginBottom: hide ? "-1rem" : "1rem" }}>
        305-7 : Nitrogen oxides (NOx), sulPHur oxides (SOx), and other
        significant air emissions{" "}
      </p>
      <Box sx={{ display: "flex", gap: 1, marginBottom: hide ? "-2rem" : "1rem"}}>
        <p className={styles.ques_heading} >
          a. What are the significant air emissions from processes:
        </p>
        <p className={styles.ques_heading}>Tons</p>
      </Box>
      <DynamicStaticTable
        {...{
          inputData,
          tables,
          setTables,
          errors: tabErrors,
          setErrors: setTabErros,
          data: data,
          defaultSegments,
          parameter: "gasName",
          disabled: disabled,
          hide: hide
        }}
      />
      {questionData.map((el) => (
        <Box key={el.fieldName} sx={{ mt: hide ? "-1rem" : "1rem" }}>
          <Box sx={{ display: "flex", gap: 0.5 }}>
            <p className={styles.ques_heading}>{el.letter}</p>
            <p className={styles.ques_heading}>{el.title}</p>
          </Box>

          <Box sx={{ ml: 3 }}>
            <InputField
              placeholder={"Enter Text"}
              fieldName={el.fieldName}
              value={formData?.[el.fieldName]}
              handleChange={(e) => {
                handleChange(el?.fieldName, e.target.value, el?.type);
              }}
              mt="-5px"
              errors={Boolean(errors[el.fieldName])}
              disabled={disabled}
            />
          </Box>
        </Box>
      ))}
      
    </>
  )
  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
        <Box sx={{ ml: "1rem", width: "98%" }}>
          <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
        </Box>
      ) : (
        <Box textAlign="right" sx={{ mt: 3 }}>
          <Button
            onClick={handleSubmit}
            variant="contained"
            sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
          >
            Save & Continue <EastIcon sx={{ ml: 2 }} />
          </Button>
        </Box>
      )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI305_7;
